import env from "./env";

export const integrationConfig = Object.freeze({
  googleMapsApiKey: env.GOOGLE_MAP_API_KEY,
  isSocketEnabled: env.IS_SOCKET_ENABLED,
});
